import { createFileRoute } from "@tanstack/react-router";

import ListDetail from "@/components/organisms/lists/ListDetail";

const ListDetailPage = () => {
  const { listId } = Route.useParams();

  return <ListDetail listId={listId} />;
};

export const Route = createFileRoute("/_authenticated/_sidebarLayout/list/$listId")({
  component: ListDetailPage,
});